import { render, staticRenderFns } from "./Observacoes.vue?vue&type=template&id=2be58845"
import script from "./Observacoes.vue?vue&type=script&lang=js"
export * from "./Observacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports